import { BaseDto } from '../base.dto';
import { InspectionType } from './inspection-type.dto';

export class InspectionStandard extends BaseDto {
  name?: string;
  inspectionFieldId?: number;
  inspectionTypes?: InspectionType[];
}
